export default __webpack_public_path__ + "static/media/rymovani.36650c63.svg";